/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Mijn PiE BFF
 * OpenAPI spec version: 1.0
 */

export type AssetType = typeof AssetType[keyof typeof AssetType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AssetType = {
  CablesOrPipes: 'CablesOrPipes',
  Connections: 'Connections',
  AgeCategoriesGasNet: 'AgeCategoriesGasNet',
  InfluenceRequests: 'InfluenceRequests',
  Other: 'Other',
} as const;
